// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.client.analytics.enums.AdproductsAnalyticsListingFilterType

export enum AdproductsAnalyticsListingFilterType {
  ALL = 'ALL',
  PAID = 'PAID',
  /**
   * @deprecated
   */
  TIER2 = 'TIER2',
  TIER2_OVER_25 = 'TIER2_OVER_25',
  TIER2_UNDER_25 = 'TIER2_UNDER_25',
  TIER3 = 'TIER3',
}

export const AdproductsAnalyticsListingFilterType_values = [
  AdproductsAnalyticsListingFilterType.ALL,
  AdproductsAnalyticsListingFilterType.PAID,
  AdproductsAnalyticsListingFilterType.TIER2,
  AdproductsAnalyticsListingFilterType.TIER2_OVER_25,
  AdproductsAnalyticsListingFilterType.TIER2_UNDER_25,
  AdproductsAnalyticsListingFilterType.TIER3,
] as const;
